import { useEffect } from 'react'

import type { LandingHeader } from '@entities/LandingPage'

import { useHeaderStore } from '@widgets/header/model/headerStore'

/*
  Applies a landing's header configuration to the layout chrome, and restores the
  site header when leaving the page.

    variant === 'custom'          -> the landing's own header
    variant === 'hidden'          -> no header
    variant === 'default' | null  -> fall back to showHeader
                                     (true -> site header, false -> none)

  Landings never get the catalog menu — that is handled in the layout, which
  renders it for the default variant only.
*/
export function useLandingHeaderVariant (header?: LandingHeader | null, ready = true) {
  const { setLandingHeader, resetHeader } = useHeaderStore()

  useEffect(() => {
    // Wait for the payload: switching chrome on a half-loaded page would flash
    // the site header and then replace it.
    if (!ready) {
      return
    }

    const variant = header?.variant ?? 'default'

    if (variant === 'custom') {
      setLandingHeader('landing', header ?? null)
    }
    else if (variant === 'hidden') {
      setLandingHeader('hidden')
    }
    else {
      setLandingHeader(header?.showHeader ? 'default' : 'hidden')
    }

    return () => resetHeader()
  }, [ header, ready, setLandingHeader, resetHeader ])
}
